import React, {Component} from "react";

export default class Disqus extends Component{
    constructor(props){
        super(props);
        this.resizeHandlerId = false;
    }
    shouldComponentUpdate(nextProps, nextState){
        if(nextProps.campaignId === this.props.campaignId){
            return false;
        }
    }
    render(){
        /*var campaignId = this.props.campaignId;
        window.disqus_config = function () {
            this.page.url = 'https://yah.ac/2#comment-3387504899';  // Replace PAGE_URL with your page's canonical URL variable
            this.page.identifier = 'https://yah.ac/1#comment-3387504899'; ; // Replace PAGE_IDENTIFIER with your page's unique identifier variable
        };*/
        (function() { // DON'T EDIT BELOW THIS LINE
            var d = window.document, s = d.createElement('script');
            s.src = 'https://yah-ac.disqus.com/embed.js';
            s.setAttribute('data-timestamp', +new Date());
            (d.head || d.body).appendChild(s);
        })();
        return (
            <div id="disqus_thread" />
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/campaign/component/Disqus.js